import { generate } from '@/utils/request';
import { VUE_APP_BILL_API } from '@/utils/index';
import { getToken } from '@/utils/auth';

const env = VUE_APP_BILL_API() + '/billing';
const config = {
    prefix: '',
    items: [
      { key: 'getInvoiceReviewList', url: env + '/invoiceReview/list', method: 'GET', loadingHide: true },
      { key: 'getInvoiceReviewDetails', url: env + '/invoiceReview/details', method: 'GET', loadingHide: true },
      { key: 'getInvoiceReviewDetail', url: env + '/invoiceReview/{invoiceId}', method: 'GET', loadingHide: true },
      { key: 'previewInvoiceReviewQuantity', url: env + '/invoiceReview/{invoiceId}/transactions/{transNo}/quantity/preview', method: 'POST', loadingHide: true },
      { key: 'updateInvoiceReviewQuantity', url: env + '/invoiceReview/{invoiceId}/transactions/{transNo}/quantity', method: 'POST', loadingHide: true },
      { key: 'deleteInvoiceReviewTransaction', url: env + '/invoiceReview/{invoiceId}/transactions/{transNo}/delete', method: 'POST', loadingHide: true },
      { key: 'markInvoiceReviewed', url: env + '/invoiceReview/{invoiceId}/review', method: 'POST', loadingHide: true },
      { key: 'getInvoiceReviewLogs', url: env + '/invoiceReview/{invoiceId}/logs', method: 'GET', loadingHide: true },
      // 获取客户报价单 ==> Price Card
      { key: 'getBillPriceCardList', url: env + '/priceCard/list', method: 'GET' },

      // 获取客户报价单 ==> Service Invoice
      { key: 'getBillServiceInvoiceList', url: env + '/serviceInvoice/list', method: 'GET' },
      // 下载Invoice Statement
      { key: 'dowmBillInvoiceStatement', url: env + '/serviceInvoice/download/statement', method: 'GET', rType: 2 },
      // 下载Invoice
      { key: 'dowmBillInvoice', url: env + '/serviceInvoice/download/invoice', method: 'GET', rType: 2 },
      // 下载Invoice Report
      { key: 'dowmBillInvoiceReport', url: env + '/serviceInvoice/download/report', method: 'GET', rType: 2 },

      // 获取收费项列表 ==> Category
      { key: 'getBillCategoryList', url: env + '/billCategory/list', method: 'GET' },
      // 获取收费项部门
      { key: 'getBillCategoryDepartments', url: env + '/select/getBillCategoryDepartments', method: 'GET' },
      { key: 'getBillCategoryPositions', url: env + '/select/getBillCategoryPositions', method: 'GET' },
      { key: 'getRpcBillCategoryList', url: env + '/rpc/billCategory/list', method: 'GET' },
      // 新建收费项
      { key: 'addBillCategoryList', url: env + '/billCategory/add', method: 'POST' },
      // 修改收费项
      { key: 'updateBillCategoryList', url: env + '/billCategory/update', method: 'POST' },
      // 删除收费项
      { key: 'deleteBillCategoryList', url: env + '/billCategory/delete', method: 'POST' },
      // 启用收费项
      { key: 'runBillCategory', url: env + '/billCategory/run', method: 'POST' },
      // 停用收费项
      { key: 'stopBillCategory', url: env + '/billCategory/stop', method: 'POST' },
      // 获取列表收费项标签  /billing/select/getBillCategoryTags
      { key: 'getBillCategoryTagsList', url: env + '/select/getBillCategoryTags', method: 'GET' },
      // 获取列表收费模版  /billing/select/getProfileTemplate
      { key: 'getBillCategoryTemplate', url: env + '/select/getProfileTemplate', method: 'GET' },

      /** 收费模板 **/
      // 获取收费模板列表(搜索)
      { key: 'getProfileTemplateList', url: env + '/profileTemplate/list', method: 'GET', loadingHide: true },
      // 新建收费模板
      { key: 'addProfileTemplateList', url: env + '/profileTemplate/add', method: 'POST' },
      // 编辑收费模板
      { key: 'updateProfileTemplate', url: env + '/profileTemplate/update', method: 'POST' },
      // 获取收费项
      { key: 'getBillCategories', url: env + '/profileTemplate/getBillCategories', method: 'GET', loadingHide: true },
      // 删除收费模板
      { key: 'delProfileTemplate', url: env + '/profileTemplate/delete', method: 'POST' },
      // 详情
      { key: 'getProfileTemplateDetail', url: env + '/profileTemplate/detail', method: 'GET' },

      /** 用户模板 **/
      // 获取用户收费模板列表(搜索)
      { key: 'getProfileClientList', url: env + '/profileClient/list', method: 'GET', loadingHide: true },
      { key: 'pendingProfileClient', url: env + '/profileClient/approvalPendingList', method: 'GET' },
      { key: 'rejectedProfileClient', url: env + '/profileClient/approvalRejectedList', method: 'GET' },
      { key: 'rejectProfileClient', url: env + '/profileClient/reject', method: 'POST' },
      { key: 'approveProfileClient', url: env + '/profileClient/approve', method: 'POST' },

      // 获取收费模版列表
      { key: 'getProfileCategories', url: env + '/profileClient/getBillCategories', method: 'GET', loadingHide: true },
      // 新增
      { key: 'addProfileClient', url: env + '/profileClient/add', method: 'POST' },
      // 修改用户收费模板
      { key: 'updateProfileClient', url: env + '/profileClient/update', method: 'POST' },
      // 删除
      { key: 'deleteProfileClient', url: env + '/profileClient/delete', method: 'POST' },
      // 启用
      { key: 'runProfileClient', url: env + '/profileClient/run', method: 'POST' },
      // 停用
      { key: 'stopProfileClient', url: env + '/profileClient/stop', method: 'POST' },

      // 获取计费流水列表(搜索) ==> Transaction
      { key: 'getTransactionList', url: env + '/transaction/list', method: 'GET' },
      { key: 'addTransactionList', url: env + '/transaction/add', method: 'POST' },
      { key: 'delTransactionList', url: env + '/transaction/delete', method: 'POST' },
      { key: 'batchDelTransactionList', url: env + '/transaction/batchDelete', method: 'POST' },

      { key: 'updateTransaction', url: env + '/transaction/update', method: 'POST' },
      // 生成交易流水记录
      { key: 'geneTransTransaction', url: env + '/transaction/generate', method: 'POST' },
      // 查看计费流水信息
      { key: 'getTransactionDetail', url: env + '/transaction/detail', method: 'GET' },

      { key: 'getTransactionInfos', url: env + '/rpc' + '/transaction/getTransactionInfos', method: 'POST' },

      // 获取账单列表 ==> Customer Profile
      { key: 'getBillPreviewInvoicesList', url: env + '/previewInvoice/list', method: 'GET' },
      // 查询发票发送邮件进度
      { key: 'getSendEmailProgress', url: env + '/previewInvoice/getSendEmailProgress', method: 'GET', loadingHide: true },
      // 下载PDF Invoice
      { key: 'downBillInvoicePDF', url: env + '/previewInvoice/download/InvoicePDF', method: 'GET', rType: 2 },
      // 下载Breakdown
      { key: 'downBillbreakdown', url: env + '/previewInvoice/download/breakdown', method: 'GET', rType: 2 },
      // 下载CSV Invoice
      { key: 'downBillInvoiceCsv', url: env + '/previewInvoice/download/InvoiceCsv', method: 'GET', rType: 2 },
      // 批量下载PDF Invoice
      { key: 'downBillInvoiceBatchPDF', url: env + '/previewInvoice/export/batch/pdf', method: 'POST', rType: 2 },
      // 批量下载Breakdown
      { key: 'downBillInvoiceBatchBreakdown', url: env + '/previewInvoice/download/batch/breakdown', method: 'POST', rType: 2 },
      // 批量 去掉最低消费
      { key: 'removePreviewInvoice', url: env + '/previewInvoice/remove/minimumWeekCharge', method: 'POST' },
      // 生成收费记录
      { key: 'geneBillTransaction', url: env + '/previewInvoice/generateTransaction', method: 'POST' },
      // 生成最终发票
      { key: 'geneBillLastInvoice', url: env + '/previewInvoice/generateLastInvoice', method: 'POST' },
      // 生成待确认发票
      { key: 'geneBillPreviewInvoice', url: env + '/previewInvoice/generatePreviewInvoice', method: 'POST', loadingHide: true },
      // 生成集装箱服务待确认发票（无需参数）
      { key: 'geneBillContainerPreviewInvoice', url: env + '/previewInvoice/generatePreviewInvoiceForSpr', method: 'POST', loadingHide: true },
      // 生成发票
      { key: 'geneBillInvoice', url: env + '/previewInvoice/generateInvoice', method: 'POST' },

      // 获取账单列表 ==> invoice
      { key: 'getBillInvoicesList', url: env + '/invoice/list', method: 'GET' },
      // 生成账单
      { key: 'geneBillGeneInvoice', url: env + '/invoice/generateInvoice', method: 'POST' },
      // 修改已支付金额
      { key: 'updateBillPayment', url: env + '/invoice/updatePayment', method: 'POST' },
      // 下载PDF Invoice
      { key: 'invoDownBillInvoicePDF', url: env + '/invoice/download/InvoicePDF', method: 'GET', rType: 2 },
      // 下载Breakdown
      { key: 'invoDownBillbreakdown', url: env + '/invoice/download/breakdown', method: 'GET', rType: 2 },
      // 批量下载PDF Invoice
      { key: 'invoExportBillpdf', url: env + '/invoice/export/batch/pdf', method: 'POST', rType: 2 },
      // 批量下载CSV Invoice
      { key: 'invoExportBillcsv', url: env + '/invoice/export/batch/csv', method: 'POST', rType: 2 },
      // 批量下载PMT CSV Invoice
      { key: 'invoExportBillPmtCsv', url: env + '/invoice/export/batch/PmtCsv', method: 'POST', rType: 2 },

      // 获取增值服务列表(搜索)==> Maunal Charge
      { key: 'getAdditionalChargeList', url: env + '/additionalCharge/list', method: 'GET' },
      { key: 'approvalPendingList', url: env + '/additionalCharge/approvalPendingList', method: 'GET' },
      { key: 'approvalRejectedList', url: env + '/additionalCharge/approvalRejectedList', method: 'GET' },
      // 查看计费流水信息
      { key: 'getAdditionalChargeDetail', url: env + '/additionalCharge/detail', method: 'GET' },
      // 修改流水记录
      { key: 'updateAdditionalChargeDetail', url: env + '/additionalCharge/update', method: 'POST' },

      // 审核通过
      { key: 'approveAdditionalCharge', url: env + '/additionalCharge/approve', method: 'POST' },
      // 审批不通过
      { key: 'rejectAdditionalCharge', url: env + '/additionalCharge/reject', method: 'POST' },
      // 新增增值服务
      { key: 'addAdditionalChargeList', url: env + '/additionalCharge/add', method: 'POST' },
      // 删除增值服务
      { key: 'delAdditionalChargeList', url: env + '/additionalCharge/delete', method: 'POST' },
      // 获取所有客户信息列表
      { key: 'getClientInfoList', url: env + '/select/getClientInfoList', method: 'GET', loadingHide: true },
      // 获取所有增值服务收费项
      { key: 'getAllAdditionalCharges', url: env + '/select/getAllAdditionalCharges', method: 'GET' },

      { key: 'getAllSearchAdditionalCharges', url: env + '/select/getAllSearchAdditionalCharges', method: 'GET' },
      { key: 'getClientCharges', url: env + '/select/getClientCharges', method: 'GET' },
      // 获取收费策略列表(搜索)==> Regular Surcharge
      { key: 'getRegularSurchargeList', url: env + '/regularSurcharge/list', method: 'GET' },
      { key: 'getRegularSurchargeType', url: env + '/select/getRegularSurchargeType', method: 'GET' },
      // 新增收费策略
      { key: 'addRegularSurchargeList', url: env + '/regularSurcharge/add', method: 'POST' },
      // 收费策略详情
      { key: 'detailRegularSurchargeList', url: env + '/regularSurcharge/detail', method: 'GET' },
      // 修改收费策略
      { key: 'updateRegularSurchargeList', url: env + '/regularSurcharge/update', method: 'POST' },
      // 删除收费策略
      { key: 'deleteRegularSurchargeList', url: env + '/regularSurcharge/delete', method: 'POST' },
      // 获取所有Regular Surcharge收费项
      { key: 'getAllRegularSurcharges', url: env + '/select/getAllRegularSurcharges', method: 'GET' },

      // 获取发票声明列表(搜索) ==> Invoice Statement
      { key: 'getBillInvoicesStatementList', url: env + '/invoiceStatement/list', method: 'POST' },
      // 发邮件
      { key: 'BillInvoicesStatementSendEmail', url: env + '/invoiceStatement/sendEmail', method: 'POST'},
      // 统计
      { key: 'BillInvoicesStatementCount', url: env + '/invoiceStatement/count', method: 'POST'},
      // 批量下载客户Invoice Statement
      { key: 'downInvoicesStatement', url: env + '/invoiceStatement/batch/download', method: 'POST', rType: 2},
      // 批量导出客户Invoice Statement Excel
      { key: 'exportInvoicesStatement', url: env + '/invoiceStatement/batch/export', method: 'POST', rType: 2},

      // 运费比较
      { key: 'compareShippingCharge', url: env + '/shippingCharge/upload', method: 'POST' },
      { key: 'chargeShippingCharge', url: env + '/shippingCharge/charge', method: 'POST' },

      { key: 'chargeShippingSurcharge', url: env + '/shippingCharge/surcharge', method: 'POST' },
      { key: 'importToDB', url: env + '/shippingCharge/importToDB', method: 'POST' },
      // 获取页面第二tab页数据 ==> DB Saved File History
      { key: 'dbSavedFileHistoryList', url: env + '/shippingCharge/dbSavedFileHistoryList', method: 'GET' },
      // 获取页面第三tab页数据 ==> Surcharged File History
      { key: 'surchargedFileHistoryList', url: env + '/shippingCharge/surchargedFileHistoryList', method: 'GET' },

      /** 运费补收 **/
      { key: 'getPostageRechargeInvoiceList', url: env + '/postageRecharge/getInvoiceList', method: 'GET' },
      { key: 'getPostageRechargeCarrierOptions', url: env + '/postageRecharge/getCarrierOptions', method: 'GET' },
      { key: 'uploadPostageRechargeInvoice', url: env + '/postageRecharge/uploadInvoice', method: 'POST', cType: 2, timeout: 10 * 60 * 1000 },
      { key: 'getPostageRechargeInvoiceDetails', url: env + '/postageRecharge/getInvoiceDetailsList', method: 'GET' },
      { key: 'getPostageRechargeInvoiceReview', url: env + '/postageRecharge/getInvoiceReview', method: 'GET', loadingHide: true },
      { key: 'updatePostageRechargeUnmatchedReason', url: env + '/postageRecharge/updateUnmatchedReason', method: 'POST' },
      { key: 'getPostageRechargeErpOrderList', url: env + '/postageRecharge/getErpOrderList', method: 'GET' },
      { key: 'matchPostageRechargeOrderManually', url: env + '/postageRecharge/matchOrderManually', method: 'POST', type: 'query' },
      { key: 'downloadPostageRechargeFile', url: env + '/postageRecharge/download', method: 'GET', rType: 2 },
      { key: 'deletePostageRechargeInvoice', url: env + '/postageRecharge/deleteInvoice', method: 'DELETE', type: 'query' },
      { key: 'getPostageRechargeItemById', url: env + '/postageRecharge/getItemById', method: 'GET' },

      { key: 'getInvoiceReportTotal', url: env + '/invoiceReport/total', method: 'POST' },
      { key: 'getInvoiceReportPallet', url: env + '/invoiceReport/pallet', method: 'POST' },
      { key: 'getInvoiceReportCbm', url: env + '/invoiceReport/cbm', method: 'POST' },
      { key: 'getInvoiceReportClientQty', url: env + '/invoiceReport/clientQty', method: 'POST' },
      { key: 'getInvoiceReportClient', url: env + '/invoiceReport/client', method: 'POST' },
      { key: 'getInvoiceReportPostage', url: env + '/invoiceReport/postage', method: 'POST' },
      { key: 'getInvoiceReportSales', url: env + '/invoiceReport/sales', method: 'POST' },
      { key: 'getAllSales', url: env + '/select/getAllSales', method: 'GET' },

      // 日志
      { key: 'getOperationLogList', url: env + '/operationLog/list', method: 'GET' },
      { key: 'getMenus', url: env + '/operationLog/getMenus', method: 'GET' },

      { key: 'calculate', url: env + '/proftCalculator/calculate', method: 'POST' },
      // 获取Charge Items
      { key: 'getChargeItems', url: env + '/proftCalculator/getChargeItems', method: 'POST' },
      // 获取Customer Type下拉列表
      { key: 'getCustomerType', url: env + '/proftCalculator/getCustomerType', method: 'GET' },
      { key: 'downloadChargeItems', url: env + '/proftCalculator/downloadChargeItems', method: 'POST', rType: 2 },

      { key: 'getClientTierList', url: env + '/clientTier/list', method: 'GET', loadingHide: true },
      { key: 'addClientTier', url: env + '/clientTier/add', method: 'POST' },
      { key: 'updateClientTier', url: env + '/clientTier/update', method: 'POST' },
      { key: 'deleteClientTier', url: env + '/clientTier/delete?id={id}', method: 'POST' },

      /** 历史成本 **/
      // 获取收费项下拉框列表 costHistory/chargeItem/select/list
      { key: 'getChItemList', url: env + '/costHistory/chargeItem/select/list', method: 'GET' },
      // 获取模板下拉框列表      costHistory/template/list
      { key: 'getTempList', url: env + '/costHistory/template/list', method: 'GET' },
      // 成本 列表(搜索)
      { key: 'getHistoricalList', url: env + '/costHistory/chargeItem/list', method: 'GET' },
      // 获取收费项的成本
      { key: 'viewHistoricalList', url: env + '/costHistory/chargeItem/cost/{template}/{chargeItemCode}', method: 'GET' },
      // 新增成本
      { key: 'addHistoricalList', url: env + '/costHistory/history/add', method: 'PUT' },
      // 获取收费项的 成本历史 列表
      { key: 'getchargeItemHisList', url: env + '/costHistory/cost/{template}/{chargeItemCode}/list', method: 'GET' },
      // 更新成本历史
      { key: 'updHistoricalList', url: env + '/costHistory/history/update', method: 'POST' },
      // 查看成本历史详情
      { key: 'detHistoricalList', url: env + '/costHistory/history/{costHistoryId}', method: 'GET' },
      // 删除成本历史
      { key: 'deleteHistoricalList', url: env + '/costHistory/history/{costHistoryId}', method: 'DELETE' },

      /** 钱包 **/
      // 钱包列表
      { key: 'getDepositList', url: env + '/wallet/page', method: 'POST' },
      // 新增/充值
      { key: 'toDeposit', url: env + '/wallet/deposit', method: 'POST' },
      // 充值记录详情/审核
      { key: 'getDepositDetail', url: env + '/wallet/detail?id={id}', method: 'GET' },
      // 充值审批
      { key: 'approveDeposit', url: env + '/wallet/approve', method: 'PUT' },
      // 详情页截图
      // { key: 'getDepositPic', url: env + '/wallet/screenshot?id={id}', method: 'GET' },
      /* 我的钱包 */
      { key: 'getMyDepositDetail', url: env + '/wallet/balance', method: 'GET' },
      /* 我的钱包 列表接口 /wallet/transactions/myWallet */
      { key: 'getMyDepositMyWallet', url: env + '/wallet/transactions/myWallet', method: 'POST' },
      /* 我的钱包 列表接口 /wallet/transactions/clientAccount */
      { key: 'getMyDepositClientAccount', url: env + '/wallet/transactions/clientAccount', method: 'POST' },
      /* 财务专用Client Accounts页面 列表接口 */
      { key: 'getMyCAPageList', url: env + '/wallet/walletList', method: 'POST' },
      /* 财务专用Client Accounts页面 获取totalBalance /wallet/totalBalance */
      { key: 'getTotalBalanceData', url: env + '/wallet/totalBalance', method: 'GET' },
      /* 财务专用Client Accounts页面 获取totalStatistics /wallet/totalStatistics */
      { key: 'getTotalStatistics', url: env + '/wallet/totalStatistics', method: 'GET' },
      /* 财务专用Client Accounts页面 获取钱包交易来源 /select/wallet/source */
      { key: 'getSelectWalletSource', url: env + '/select/wallet/source', method: 'GET' },
      /* 财务专用Client Accounts页面 导出 /wallet/exportTransactions */
      { key: 'exportTransactionsList', url: env + '/wallet/exportTransactions', method: 'POST', rType: 2 },

      /** 客户库存计费 **/
      /* 列表页 --》》列表页数据 --》》 get /inventoryPrice/list 王立莹*/
      { key: 'getCustomerInventoryPricing', url: env + '/inventoryPrice/list', method: 'GET' },
      /* 列表页 --》》库存金额、未支付金额 --》》  get /inventoryPrice/total 王立莹*/
      { key: 'getCustomerInventoryTotal', url: env + '/inventoryPrice/total', method: 'GET', loadingHide: true },
      /* 弹出框 --》》新增客户库存价格 --》》  post /inventoryPrice/add 王立莹*/
      { key: 'addCustomerInventoryTotal', url: env + '/inventoryPrice/add', method: 'POST' },
      /* 弹出框 --》》编辑客户库存价格 --》》  post /inventoryPrice/update 王立莹*/
      { key: 'updateCustomerInventoryTotal', url: env + '/inventoryPrice/update', method: 'POST' },
      /* 列表页 --》》删除客户库存价格 --》》  post /inventoryPrice/delete 王立莹*/
      { key: 'deleteCustomerInventoryTotal', url: env + '/inventoryPrice/delete', method: 'POST' },

      // 库存查询 后端导出  get  /storage-charge-details/export
      { key: 'getStorageChargeDetailsExport', url: env + '/storage-charge-details/export', method: 'GET', rType: 2 },
    ]
};
export default {
    ...generate(config),
};

/**
 * object转化成url拼接样式
 * @param obj 需要转化的参数
 */
const objToUrl = obj => {
  const arr = [];
  for (const i in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(i)) {
          arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
      }
  }
  return arr.join('&');
};
// 调用
export function getFileUrl(key, data) {
  const fixUrl = config.items.filter(item => item.key == key)[0].url + `?token=${window.btoa(encodeURIComponent(getToken()))}`;
  if (data) {
    return window.open(`${fixUrl}&${objToUrl(data)}`, '_blank');
  }
  return window.open(fixUrl, '_blank');
}
